import { render, staticRenderFns } from "./FeedBlock.vue?vue&type=template&id=a4a15cca&scoped=true&"
import script from "./FeedBlock.vue?vue&type=script&lang=js&"
export * from "./FeedBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4a15cca",
  null
  
)

export default component.exports